import { render, staticRenderFns } from "./TicketDependentSidebar.vue?vue&type=template&id=39dd9540&scoped=true"
import script from "./TicketDependentSidebar.vue?vue&type=script&lang=js"
export * from "./TicketDependentSidebar.vue?vue&type=script&lang=js"
import style0 from "./TicketDependentSidebar.vue?vue&type=style&index=0&id=39dd9540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dd9540",
  null
  
)

export default component.exports